// @ts-nocheck c3f301ee
import * as stateManagement from '#packages/stateManagement';
import experiment from 'experiment';

const trackAppUpgrade = function (editorAPI, applicationId, appDefinitionId?) {
  editorAPI.store.dispatch(
    experiment.isOpen('se_appDefIdUpdates') && appDefinitionId
      ? stateManagement.tpa.actions.addAppToTrackForUpgradeByAppDefId(
          appDefinitionId,
        )
      : stateManagement.tpa.actions.addAppToTrackForUpgrade(applicationId),
  );
};

export { trackAppUpgrade };
